module.exports = __webpack_public_path__ + "img/vx_mlh.8ebef2ab.png";